/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlSelectedAllCondition
 */
export interface ControlSelectedAllCondition {
    /**
     * 
     * @type {string}
     * @memberof ControlSelectedAllCondition
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSelectedAllCondition
     */
    question_id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlSelectedAllCondition
     */
    option_ids: Array<string>;
}

/**
 * Check if a given object implements the ControlSelectedAllCondition interface.
 */
export function instanceOfControlSelectedAllCondition(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "question_id" in value;
    isInstance = isInstance && "option_ids" in value;

    return isInstance;
}

export function ControlSelectedAllConditionFromJSON(json: any): ControlSelectedAllCondition {
    return ControlSelectedAllConditionFromJSONTyped(json, false);
}

export function ControlSelectedAllConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSelectedAllCondition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'question_id': json['question_id'],
        'option_ids': json['option_ids'],
    };
}

export function ControlSelectedAllConditionToJSON(value?: ControlSelectedAllCondition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'question_id': value.question_id,
        'option_ids': value.option_ids,
    };
}

